import { IsNotEmpty, IsUUID, IsOptional } from 'class-validator';

import { GetAccountUsersGroupsQueryDto } from './get-account-users-groups-query.dto';

export class RemoveAllUserAccountDto {
  @IsUUID()
  @IsNotEmpty()
  accountId: string;

  @IsUUID()
  @IsNotEmpty()
  userId: string;

  @IsOptional()
  filter?: GetAccountUsersGroupsQueryDto;
}
